module.exports = __webpack_public_path__ + "img/RDN.b0595aae.svg";